import MapList from './MapList'
import MapShow from './MapShow'

const mapsEntrypoints = {
  list: MapList,
  show: MapShow,
}

export default mapsEntrypoints
